/**
 * Custom mobile drawer – open/close and body scroll lock
 */
(function () {
  const drawer = document.getElementById('custom-mobile-drawer');
  if (!drawer) return;

  const trigger = drawer.querySelector('.custom-mobile-drawer__trigger');
  const overlay = document.getElementById('custom-mobile-drawer-overlay');
  const panel = document.getElementById('custom-mobile-drawer-panel');

  const OPEN_CLASS = 'is-open';
  const BODY_CLASS = 'custom-mobile-drawer-open';

  function open() {
    drawer.classList.add(OPEN_CLASS);
    drawer.setAttribute('aria-hidden', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (panel) panel.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add(BODY_CLASS);
  }

  function close() {
    drawer.classList.remove(OPEN_CLASS);
    drawer.setAttribute('aria-hidden', 'true');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (panel) panel.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove(BODY_CLASS);
  }

  function toggle() {
    if (drawer.classList.contains(OPEN_CLASS)) {
      close();
    } else {
      open();
    }
  }

  if (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggle();
    });
  }

  if (overlay) {
    overlay.addEventListener('click', close);
  }

  var closeBtn = drawer.querySelector('[data-custom-drawer-close]');
  if (closeBtn) {
    closeBtn.addEventListener('click', close);
  }

  panel.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains(OPEN_CLASS)) {
      close();
    }
  });

  // Close when a menu link is clicked (navigating)
  drawer.querySelectorAll('.custom-mobile-drawer__menu-item[href]').forEach(function (link) {
    link.addEventListener('click', function () {
      close();
    });
  });
})();
